var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelopeOpen = function SvgEnvelopeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 154"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M134.75 28.876v48.612l-49.292 35.606a14.404 14.404 0 0 1-16.907 0L19.25 77.488V28.876a9.625 9.625 0 0 1 9.625-9.625h96.25a9.625 9.625 0 0 1 9.625 9.625",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M99.08 12.465C94.024 8.778 83.978-.105 77 .001c-6.978-.105-17.021 8.774-22.08 12.464l-9.201 6.786h62.562zM19.25 38.801c-7.183 5.321-12.834 9.52-13.719 10.227A14.437 14.437 0 0 0 0 60.373v3.204l19.25 13.908zm129.219 10.227c-.885-.692-6.536-4.89-13.719-10.205v38.662L154 63.577v-3.204a14.437 14.437 0 0 0-5.531-11.345M77 125.465a24.011 24.011 0 0 1-14.095-4.569L0 75.454v64.109C0 147.536 6.464 154 14.438 154h125.125c7.973 0 14.437-6.464 14.437-14.437V75.454l-62.905 45.442A24.063 24.063 0 0 1 77 125.466"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 12,
    x: 48,
    y: 43,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 12,
    x: 48,
    y: 64,
    rx: 6
  }))));
};
export default SvgEnvelopeOpen;